var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Add therapists",
        label: "Add " + _vm.input.length + " therapist(s)",
        disabled: !_vm.input.length && false
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSubmit
      }
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-4", style: { width: "40rem" } },
        [
          _c(
            "div",
            { staticClass: "px-8" },
            [
              _c("BlInputSearch", {
                attrs: { input: _vm.searchInput },
                on: { changed: _vm.onInputSearch }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.fetchLoading
            ? _c("div", { staticClass: "h-64 grid place-items-center" }, [
                _c("div", { staticClass: "blum-loader-sm" })
              ])
            : !_vm.userOptions.length
            ? _c(
                "div",
                {
                  staticClass: "h-64 flex flex-col items-center justify-center"
                },
                [
                  _c("BlTextBody1", {
                    staticClass: "text-center",
                    attrs: { text: "Team member(s) not found." }
                  })
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "px-8 flex flex-col overflow-y-auto",
                  style: { maxHeight: "calc(100vh - 20rem)" }
                },
                _vm._l(_vm.userOptions, function(user) {
                  return _c(
                    "div",
                    {
                      key: user.id,
                      staticClass:
                        "py-2 flex items-center gap-3 border-b border-slate-400 cursor-pointer",
                      class: { "pointer-events-none": _vm.isDisabled(user.id) },
                      on: {
                        click: function($event) {
                          return _vm.onChange(user)
                        }
                      }
                    },
                    [
                      _c("BlInputCheck", {
                        attrs: {
                          checked: _vm.isChecked(user.id),
                          disabled: _vm.isDisabled(user.id)
                        },
                        on: {
                          changed: function($event) {
                            return _vm.onChange(user)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-1 truncate" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-slate-1000 truncate",
                            attrs: { text: user.name }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-slate-700 truncate",
                            attrs: { text: user.email }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                0
              )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bda71b82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bda71b82","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/UsersMultiSelect.vue
// module id = null
// module chunks = 